import React from 'react';
import dynamic from 'next/dynamic';
import { withRouter } from 'next/router';
import withApollo from '../lib/apollo';
import loading from '../lib/loading';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';

const Education = dynamic(() => import('../components/Education'), {
  ssr: true,
  loading,
});

const EducationPage = () => <Education />;

EducationPage.getInitialProps = redirectRouteToDomain(
  'education',
);

export default withApollo(withRouter(EducationPage));
